import Api from '@/services/Index';

const getAll = async (config) => {
    return Api.get('/housing/requests/list',config);
}
const show = async (id) => {
    return Api.get('housing/requests/detail/'+id);
};
const getAllAdmin = async (config) => {
    return Api.get('/housing/requests',config);
}
const showAdmin = async (id) => {
    return Api.get(`/housing/requests/${id}`);
}
const downloadFile = async (uuid) => {
    return Api.get(`/housing/requests/download/${uuid}`, {responseType:'arraybuffer'});
}
const changeStatusRequest = async (id,formData) => {
    return Api.post(`/housing/requests/${id}/change-status`,formData);
}
const addExpenseDetail = async (id,formData) => {
    let config={
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return Api.post(`/housing/requests/add-expense-detail/${id}`,formData,config);
}

export default {
    getAll,
    show,
    getAllAdmin,
    showAdmin,
    downloadFile,
    changeStatusRequest,
    addExpenseDetail
}
